export const DRIVER_PROFILE = "DRIVER_PROFILE";
export const GET_GENDER = "GET_GENDER";
export const GET_TITLE = "GET_TITLE";
export const GET_CHARGING_SITES = "GET_CHARGING_SITES";
export const DRIVER_PROFILE_CREATED = "DRIVER_PROFILE_CREATED";
export const DRIVER_PROFILE_UPDATED = "DRIVER_PROFILE_UPDATED";
export const DRIVER_PROFILE_CREATION_FAILED = "DRIVER_PROFILE_CREATION_FAILED";
export const GET_DRIVER_PROFILE = "GET_DRIVER_PROFILE";
export const GET_VEHICLE_BRANDS = "GET_VEHICLE_BRANDS";
export const GET_VEHICLE_CHARGER_TYPES = "GET_VEHICLE_CHARGER_TYPES";
export const GET_VEHICLE_MODELS = "GET_VEHICLE_MODELS";
export const UPDATE_DRIVER_VEHICLE = "UPDATE_DRIVER_VEHICLE";
export const CREATE_DRIVER_VEHICLE = "CREATE_DRIVER_VEHICLE";
export const DELETE_DRIVER_VEHICLE = "DELETE_DRIVER_VEHICLE";
export const GET_ADDRESS_TYPE = "GET_ADDRESS_TYPE";
export const GET_CITY = "GET_CITY";
export const GET_COUNTRY = "GET_COUNTRY";
export const GET_STATE = "GET_STATE";
export const GET_READ_NOTIFICATION = "GET_READ_NOTIFICATION";
export const DRIVER_AUTHENTICATION_SUCCESS = "DRIVER_AUTHENTICATION_SUCCESS";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const DRIVER_AUTHENTICATION_IN_PROCESS =
  "DRIVER_AUTHENTICATION_IN_PROCESS";
export const DRIVER_AUTHENTICATION_FAILED = "DRIVER_AUTHENTICATION_FAILED";
export const PASSWORD_RESET_FAILED = "PASSWORD_RESET_FAILED";
export const GET_STATION_MANAGER_NUMBER = "GET_STATION_MANAGER_NUMBER";
export const GET_BOOKINGS = "GET_BOOKINGS";
export const GET_BOOKING_ADDRESS = "GET_BOOKING_ADDRESS";
export const GET_CHARGE_BOX_CHARGING = "GET_CHARGE_BOX_CHARGING"
export const GET_BOOKING_DETAILS = "GET_BOOKING_DETAILS";
export const GET_CHARGING_SITES_BUNDLES = "GET_CHARGING_SITES_BUNDLES";
export const GET_PARKING_SLOTS = "GET_PARKING_SLOTS";
export const BOOKING_CREATED_SUCCESSFULLY = "BOOKING_CREATED_SUCCESSFULLY";
export const GET_STATION_NAME = "GET_STATION_NAME";
export const GET_PLAN_SELECTION_NAME = "GET_PLAN_SELECTION_NAME";
export const GET_PLAN_STATION_BUNDLE = "GET_PLAN_STATION_BUNDLE";
export const CLEAR_PARKING_SLOTS = "CLEAR_PARKING_SLOTS";
export const DRIVER_BUNDLE_SUBSCRIPTION_CREATED =
  "DRIVER_BUNDLE_SUBSCRIPTION_CREATED";
export const GET_BUNDLE_DAY_REFERENCE = "BUNDLE_DAY_REFERENCE";
export const GET_DAY_REFERENCE_CHARGING_SITE_BUNDLE =
  "GET_DAY_REFERENCE_CHARGING_SITE_BUNDLE";
export const GET_DAYSHARE_PARKING_SLOTS = "GET_DAYSHARE_PARKING_SLOTS";
export const GET_DRIVER_BUNDLE_SUBSCRIPTIONS =
  "GET_DRIVER_BUNDLE_SUBSCRIPTIONS";
export const API_ENDPOINT_FAILED = "API_ENDPOINT_FAILED";
export const GET_PAYMENT_DETAIL = "GET_PAYMENT_DETAIL";
export const GET_CHARGE_DETAIL = "GET_CHARGE_DETAIL";
export const GET_DRIVER_CHARGING_SITES = "GET_DRIVER_CHARGING_SITES";
export const CLEAR_DRIVER_CHARGING_SITE = "CLEAR_DRIVER_CHARGING_SITE";
export const GET_ALL_CHARGING_SITES = "GET_ALL_CHARGING_SITES";
export const SHOW_TOAST = "SHOW_TOAST";
export const UPDATE_EV_CHARGING_SITE_ID = "UPDATE_EV_CHARGING_SITE_ID";
export const APP_ONLINE_OFFLINE_MODE = "APP_ONLINE_OFFLINE_MODE";
